import { DeviceId } from '@service-initiation/shared-clients-tech-care-services';

import CellPhone from '../assets/cell-phone.png';
import GamingConsole from '../assets/gaming-console.png';
import Laptop from '../assets/laptop.png';
import OtherImage from '../assets/other-image.png';
import Tablet from '../assets/tablet.png';

export const deviceIdToImage: Record<number, string> = {
  [DeviceId.CellPhone]: CellPhone,
  [DeviceId.GamingConsole]: GamingConsole,
  [DeviceId.Laptop]: Laptop,
  [DeviceId.Other]: OtherImage,
  [DeviceId.Tablet]: Tablet,
};

export const getDeviceImage = (device: { id?: number; image_link: string }) => {
  if (device.id === DeviceId.OtherChild) {
    return '';
  }
  return deviceIdToImage[device.id || DeviceId.Other] || device.image_link;
};
